import request from 'sb-request'
import actions from 'redux/actions'
import { getCookieValue } from 'helpers'
import { reducers, getState } from 'redux/core'
import { constants, getGqlQuery } from 'common/helpers'


/**
 * Fetches collection data
 *
 * @param {Object} params
 * @param {String} params.slug
 * @param {('male'|'female')} params.gender
 *
 * @returns {Promise} request
 */
const fetch = ({ slug, gender }) => (
  request.post('graphql?name=collection', {
    body: {
      query: `{
        ${getGqlQuery('collection', { slug, gender })} {
          id
          url
          title
          video
          gender
          status
          footer
          gallery
          products {
            id
            img
            sex
            type
            name
            brand
            rating
            category
          }
          imgMobile
          imgDesktop
          howItWorks
          appearance
          description
          collectionType
        }
      }`,
    },
    modifyResult: (data) => {
      const collection = data && data.collection || {}
      const { view: { collectionLandingPage: { products: selectedProducts } } } = getState()
      const { products: _products = [], collectionType } = collection

      const isSameLength    = selectedProducts.length === _products.length
      const isSameProducts  = _products.every(({ id }, index) =>
        selectedProducts[index] && selectedProducts[index].id === id
      )

      const products = _products.map((product, index) => ({
        ...product,
        isSelected: isSameProducts && isSameLength ? selectedProducts[index].isSelected : true,
      }))

      return {
        ...collection,
        products,
        collectionType: collectionType === null ? 'mixed' : collectionType,
      }
    },
    // mock: true,
    // mockData: {
    //   data: {
    //     collection: {
    //       "id": 14,
    //       "title": "Game Day!",
    //       "description": "The best sporty scents offer a dose of clean, fresh notes backed by a hint of the outdoors to get you moving.  These picks are ideal for any outdoor activity you love most, whether it's hiking, sailing, or just manning a pool table at your local. Your scent-MVP awaits.",
    //       "gender": "male",
    //       "url": "/collections-men/sporty",
    //       "status": "ACTIVE",
    //       "products": [
    //         {"id":706,"name":"Vanille Blackberry","brand":"Comptoir Sud Pacifique","img":"https://cdn.scentbird.com/perfume/normal/img-706.jpg","sex":"female","category":"Eau de Toilette","type":"EauDeToilette","rating":"0"},
    //         {"id":694,"name":"Like This","brand":"Etat Libre d`Orange","img":"https://cdn.scentbird.com/perfume/normal/img-694.jpg","sex":"female","category":"Eau de Parfum","type":"EauDeParfum","rating":"0"},
    //         {"id":707,"name":"Amethyst Eclat","brand":"Lalique","img":"https://cdn.scentbird.com/perfume/normal/img-707.jpg","sex":"female","category":"Eau de Parfum","type":"EauDeParfum","rating":"0"},
    //         {"id":697,"name":"Dark Purple","brand":"Montale","img":"https://cdn.scentbird.com/perfume/normal/img-697.jpg","sex":"female","category":"Eau de Parfum","type":"EauDeParfum","rating":"0"},
    //         {"id":709,"name":"Bergamot","brand":"Rag & Bone","img":"https://cdn.scentbird.com/perfume/normal/img-709.jpg","sex":"unisex","category":"Eau de Parfum","type":"EauDeParfum","rating":"0"},
    //         {"id":712,"name":"Neroli","brand":"Rag & Bone","img":"https://cdn.scentbird.com/perfume/normal/img-null.jpg","sex":"unisex","category":"Eau de Parfum","type":"EauDeParfum","rating":"0"},
    //         {"id":711,"name":"Oddity","brand":"Rag & Bone","img":"https://cdn.scentbird.com/perfume/normal/img-711.jpg","sex":"unisex","category":"Eau de Parfum","type":"EauDeParfum","rating":"0"},
    //         {"id":2,"name":"Dolce","brand":"Dolce & Gabbana","img":"https://cdn.scentbird.com/perfume/normal/img-2.jpg","sex":"female","category":"Eau de Parfum","type":"EauDeParfum","rating":"4.1"},
    //         {"id":1007723,"name":"Black Orchid","brand":"Tom Ford","img":"https://cdn.scentbird.com/perfume/normal/img-1007723.jpg","sex":"female","category":"Eau de Parfum","type":"EauDeParfum","rating":"3.6"},
    //         {"id":1,"name":"Be Delicious","brand":"DKNY","img":"https://cdn.scentbird.com/perfume/normal/img-1.jpg","sex":"female","category":"Eau de Toilette","type":"EauDeToilette","rating":"4.2"},
    //         {"id":3,"name":"Brit Sheer","brand":"Burberry","img":"https://cdn.scentbird.com/perfume/normal/img-3.jpg","sex":"female","category":"Eau de Toilette","type":"EauDeToilette","rating":"4.1"},
    //         {"id":1361930,"name":"Candy","brand":"Prada","img":"https://cdn.scentbird.com/perfume/normal/img-1361930.jpg","sex":"female","category":"Eau de Parfum","type":"EauDeParfum","rating":"4.1"},
    //         {"id":36,"name":"Bright Crystal Absolu","brand":"Versace","img":"https://cdn.scentbird.com/perfume/normal/img-36.jpg","sex":"female","category":"Eau de Parfum","type":"EauDeParfum","rating":"4.5"},
    //       ],
    //       "image": "https://cdn.scentbird.com/collections/1537194900150.jpg",
    //       "imgDesktop": "https://cdn.scentbird.com/collections/1537194900150.jpg",
    //       "imgMobile": "https://cdn.scentbird.com/collections/1537194900150.jpg",
    //       "howItWorks": "default",
    //       "footer": "full",
    //       "video": "",
    //       "gallery": [],
    //     },
    //   },
    // },
  })
    .then(
      (collection) => {
        reducers.view.collectionLandingPage.set(collection)

        return collection
      })
)

/**
 * Saves selected products to localStorage
 */
const saveProductsToStorage = () => {
  const { view: { collectionLandingPage: { products } } } = getState()

  // Reduce amount of data for cookie
  const productsData = products.map(({ id, isSelected }) => ({ id, isSelected }))

  actions.misc.localStorage.setItem(constants.localStorageNames.collectionLandingPageItems, productsData)
}

/**
 * Clear selected products from cookies
 */
const clearProducts = () => {
  actions.misc.localStorage.removeItem(constants.localStorageNames.collectionLandingPageItems)
  reducers.view.collectionLandingPage.clearProducts()
}

/**
 * Toggle product's isSelected property
 */
const toggleProductSelect = (toggleId) => {
  const { view: { collectionLandingPage: { products: oldProducts } } } = getState()

  const products = oldProducts.map(({ id, isSelected, ...rest }) => ({
    id,
    isSelected: toggleId === id ? !isSelected : isSelected,
    ...rest,
  }))

  reducers.view.collectionLandingPage.setProducts(products)

  return Promise.resolve(products)
}

const moveProductsFromCookieToStorage = () => {
  const products = (getCookieValue(constants.cookieNames.postponed.collectionLandingPageItems) || [])

  if (products.length) {
    actions.misc.localStorage.setItem(constants.localStorageNames.collectionLandingPageItems, products)
    actions.misc.cookies.removeItem(constants.cookieNames.postponed.collectionLandingPageItems)
  }
}

const setProductsFromStorage = () => {
  moveProductsFromCookieToStorage()

  const products = actions.misc.localStorage.getItem(constants.localStorageNames.collectionLandingPageItems, [])

  reducers.view.collectionLandingPage.setProducts(products)
}


export default {
  fetch,
  clearProducts,
  toggleProductSelect,
  saveProductsToStorage,
  setProductsFromStorage,
}
